export default __webpack_public_path__ + "static/media/logo_cor.75321ca3.png";